(function () {
    'use strict';

    angular
        .module('surveyCampaignsModule')
        .controller('SurveyCampaignQuestionnaireSectionEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'campaign', 'questionnaireTemplate', 'questionnaireSection', 'oddSurveyQuestionnaireTemplateService','modalService','notificationService'];

    function Controller($scope, $state, campaign, questionnaireTemplate, questionnaireSection, oddSurveyQuestionnaireTemplateService, modalService, notificationService) {
        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.campaign = campaign;
        $scope.questionnaireSection = questionnaireSection;
        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.questionnaireSection = questionnaireSection;


        // Go To Questionnaire Template
        $scope.goToSurveyCampaign = function () {
            $state.go('odd.surveyCampaignEdit', { ODDCampaignID: $scope.campaign.ODDCampaignID }, { reload: true });
        };


        // Go To Question
        $scope.goToComponent = function (component) {
            if (component.ODDQuestionID){
            $state.go('odd.surveyCampaignEdit.section.questionEdit', {
                ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                ODDQuestionnaireSectionID: questionnaireSection.ODDSectionID,
                ODDQuestionID: component.ODDQuestionID
            });
            }
            else if (component.ODDStaticTextID) {
                $state.go('odd.surveyCampaignEdit.section.staticTextEdit', {
                    ODDStaticTextID: component.ODDStaticTextID
                });

            }
        };

        $scope.addPageBreak = function () {
            return oddSurveyQuestionnaireTemplateService.createPageBreak(
                    questionnaireTemplate.ODDBusinessUnitID,
                    questionnaireTemplate.ODDQuestionnaireID,
                    questionnaireSection.ODDSectionID).then(function () {
                        $state.reload();
                        notificationService.notify('Page Break has been created');
                    });
        };
        $scope.goToComponentListEdit = function () {
            $state.go('odd.surveyCampaignEdit.section.editComponentList', {
                ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                ODDQuestionnaireSectionID: questionnaireSection.ODDSectionID
            });
        };

        // Add Question
        $scope.addQuestion = function () {

            // Fetch types
            oddSurveyQuestionnaireTemplateService.getQuestionTypes()
                .then(function (questionTypes) {
                    var modal = modalService.displayTemplateModal(
                        'Select a Question Type',
                        require('../../../shared/odd/questionnaireTemplate/questionType/oddQuestionType.modal.tpl.html'),
                        {
                            questionTypes: questionTypes,
                            ctrl: { step: 'questionTypes' },
                            onQuestionTypeSelection: function (ctrl, questionType) {
                                if (questionType.Code.indexOf('MultipleChoice') === 0) {
                                    ctrl.step = 'multipleChoiceTemplates';
                                    ctrl.questionType = questionType;
                                    modal.$scope.title = 'Select a ' + questionType.TitleEN + ' Template';

                                    oddSurveyQuestionnaireTemplateService.getQuestionMultiChoiceTemplates().then(function (multiChoiceTemplates) {
                                        ctrl.multiChoiceTemplates = multiChoiceTemplates;
                                    });
                                } else {
                                    modal.$promise.then(modal.hide);

                                    $state.go('odd.surveyCampaignEdit.section.addQuestion', {
                                        ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                                        ODDQuestionnaireSectionID: questionnaireSection.ODDSectionID,
                                        ODDQuestionTypeCode: questionType.Code
                                    });
                                }
                            },
                            onUserDefinedMultiChoiceSelection: function (ctrl) {
                                modal.$promise.then(modal.hide);

                                $state.go('odd.surveyCampaignEdit.section.addQuestion', {
                                    ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                                    ODDQuestionnaireSectionID: questionnaireSection.ODDSectionID,
                                    ODDQuestionTypeCode: ctrl.questionType.Code
                                });
                            },
                            onMultiChoiceTemplateSelection: function (ctrl, multiChoiceTemplate) {
                                modal.$promise.then(modal.hide);

                                $state.go('odd.surveyCampaignEdit.section.addQuestionTemplate', {
                                    ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                                    ODDQuestionnaireSectionID: questionnaireSection.ODDSectionID,
                                    ODDQuestionTypeCode: ctrl.questionType.Code,
                                    ODDQuestionChoiceTemplateID: multiChoiceTemplate.ODDQuestionChoiceTemplateID
                                });
                            }
                        },
                        false
                    )
                });
        };
        $scope.addStaticText = function () {
            $state.go('odd.surveyCampaignEdit.section.addStaticText', {});
        };

        $scope.addSection = function (section) {
            var sectionToCreate = {
                ODDSectionID: section.ODDSectionID
            };

            oddSurveyQuestionnaireTemplateService.createSection($scope.campaign.ODDBusinessUnitID, $scope.campaign.ODDExternalPartyID,
                $scope.campaign.ODDCampaignID, $scope.questionnaire.ODDCampaignQuestionnaireID, sectionToCreate).then(function () {
                $scope.$hide();
                $state.reload();
            });
        };

        $scope.goToCampaigns = function () {
            $state.go('odd.surveyCampaigns', { ODDBusinessUnitID: $scope.campaign.ODDBusinessUnitID }, { reload: true });
        };
    }
})();
